module.exports = "/images/signature.svg";